import axios from '../../../../shared/axios';

import * as actionTypes from '../constants/sms-chat';

import { AppDispatch } from '../../../../store';
import { validateObj } from '../../../../shared/utils';

import {
  ChangeChatNameRequest,
  ChatsCollection,
  CheckExistedChatRequest,
  DeleteChatRequest,
  GetChatsRequest,
  LinkToInsuredRequest,
  MarkAsReadRequest,
  MarkAsStarredRequest,
  MarkAsUnreadRequest,
  MuteNotificationRequest,
  UnlinkConversationFromInsuredsNotesRequest,
  UnmuteNotificationRequest,
  UpdateChatNamesRequest,
} from '../../models';

const getChatsStart = () => {
  return {
    type: actionTypes.SMS_CHAT_GET_CHATS_START,
  };
};

const getChatsSuccess = (data: ChatsCollection) => {
  return {
    type: actionTypes.SMS_CHAT_GET_CHATS_SUCCESS,
    data,
  };
};

const getChatsFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_GET_CHATS_FAIL,
    error,
  };
};

export const getChats = (params: GetChatsRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<ChatsCollection>((resolve, reject) => {
      dispatch(getChatsStart());

      const url = `/sms-chat/get-chats`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getChatsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getChatsFail(err));
          reject(err);
        });
    });
  };
};

export const setChats = (data: ChatsCollection) => {
  return {
    type: actionTypes.SMS_CHAT_SET_CHATS,
    data,
  };
};

export const setLocalChats = (data: ChatsCollection) => {
  return {
    type: actionTypes.SMS_CHAT_SET_LOCAL_CHATS,
    data,
  };
};

const linkToInsuredStart = () => {
  return {
    type: actionTypes.SMS_CHAT_LINK_TO_INSURED_START,
  };
};

const linkToInsuredSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_LINK_TO_INSURED_SUCCESS,
    data,
  };
};

const linkToInsuredFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_LINK_TO_INSURED_FAIL,
    error,
  };
};

export const linkToInsured = (params: LinkToInsuredRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(linkToInsuredStart());

      const url = `/sms-chat/link-to-insured`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(linkToInsuredSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(linkToInsuredFail(err));
          reject(err);
        });
    });
  };
};

const changeChatNameStart = () => {
  return {
    type: actionTypes.SMS_CHAT_CHANGE_CHAT_NAME_START,
  };
};

const changeChatNameSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_CHANGE_CHAT_NAME_SUCCESS,
    data,
  };
};

const changeChatNameFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_CHANGE_CHAT_NAME_FAIL,
    error,
  };
};

export const changeChatName = (params: ChangeChatNameRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(changeChatNameStart());

      const url = `/sms-chat/change-chat-name`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(changeChatNameSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(changeChatNameFail(err));
          reject(err);
        });
    });
  };
};

const unlinkConversationToInsuredsNotesStart = () => {
  return {
    type: actionTypes.SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_START,
  };
};

const unlinkConversationToInsuredsNotesSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_SUCCESS,
    data,
  };
};

const unlinkConversationToInsuredsNotesFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_FAIL,
    error,
  };
};

export const unlinkConversationToInsuredsNotes = (params: UnlinkConversationFromInsuredsNotesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(unlinkConversationToInsuredsNotesStart());

      const url = `/sms-chat/unlink-conversation-from-insureds-notes`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(unlinkConversationToInsuredsNotesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(unlinkConversationToInsuredsNotesFail(err));
          reject(err);
        });
    });
  };
};

const checkExistedChatStart = () => {
  return {
    type: actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_START,
  };
};

const checkExistedChatSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS,
    data,
  };
};

const checkExistedChatFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_FAIL,
    error,
  };
};

export const checkExistedChat = (params: CheckExistedChatRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(checkExistedChatStart());

      const url = `/sms-chat/check-existed-chat`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(checkExistedChatSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(checkExistedChatFail(err));
          reject(err);
        });
    });
  };
};

const deleteChatStart = () => {
  return {
    type: actionTypes.SMS_CHAT_DELETE_CHAT_START,
  };
};

const deleteChatSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_DELETE_CHAT_SUCCESS,
    data,
  };
};

const deleteChatFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_DELETE_CHAT_FAIL,
    error,
  };
};

export const deleteChat = (params: DeleteChatRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(deleteChatStart());

      const url = `/sms-chat/delete-chat`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(deleteChatSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteChatFail(err));
          reject(err);
        });
    });
  };
};

const markAsUnreadStart = () => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_UNREAD_START,
  };
};

const markAsUnreadSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_UNREAD_SUCCESS,
    data,
  };
};

const markAsUnreadFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_UNREAD_FAIL,
    error,
  };
};

export const markAsUnread = (params: MarkAsUnreadRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(markAsUnreadStart());

      const url = `/sms-chat/mark-as-unread`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(markAsUnreadSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(markAsUnreadFail(err));
          reject(err);
        });
    });
  };
};

const muteNotificationStart = () => {
  return {
    type: actionTypes.SMS_CHAT_MUTE_NOTIFICATION_START,
  };
};

const muteNotificationSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_MUTE_NOTIFICATION_SUCCESS,
    data,
  };
};

const muteNotificationFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_MUTE_NOTIFICATION_FAIL,
    error,
  };
};

export const muteNotification = (params: MuteNotificationRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(muteNotificationStart());

      const url = `/sms-chat/mute-notification`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(muteNotificationSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(muteNotificationFail(err));
          reject(err);
        });
    });
  };
};

const unmuteNotificationStart = () => {
  return {
    type: actionTypes.SMS_CHAT_UNMUTE_NOTIFICATION_START,
  };
};

const unmuteNotificationSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_UNMUTE_NOTIFICATION_SUCCESS,
    data,
  };
};

const unmuteNotificationFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_UNMUTE_NOTIFICATION_FAIL,
    error,
  };
};

export const unmuteNotification = (params: UnmuteNotificationRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(unmuteNotificationStart());

      const url = `/sms-chat/unmute-notification`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(unmuteNotificationSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(unmuteNotificationFail(err));
          reject(err);
        });
    });
  };
};

const updateChatNamesStart = () => {
  return {
    type: actionTypes.SMS_CHAT_UPDATE_CHAT_NAMES_START,
  };
};

const updateChatNamesSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_UPDATE_CHAT_NAMES_SUCCESS,
    data,
  };
};

const updateChatNamesFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_UPDATE_CHAT_NAMES_FAIL,
    error,
  };
};

export const updateChatNames = (params: UpdateChatNamesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(updateChatNamesStart());

      const url = `/sms-chat/update-chat-names`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(updateChatNamesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(updateChatNamesFail(err));
          reject(err);
        });
    });
  };
};

const markAsStarredStart = () => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_STARRED_START,
  };
};

const markAsStarredSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_STARRED_SUCCESS,
    data,
  };
};

const markAsStarredFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_STARRED_FAIL,
    error,
  };
};

export const markAsStarred = (params: MarkAsStarredRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(markAsStarredStart());

      const url = `/sms-chat/mark-as-starred`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(markAsStarredSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(markAsStarredFail(err));
          reject(err);
        });
    });
  };
};

const markAsReadStart = () => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_READ_START,
  };
};

const markAsReadSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_READ_SUCCESS,
    data,
  };
};

const markAsReadFail = (error: any) => {
  return {
    type: actionTypes.SMS_CHAT_MARK_AS_READ_FAIL,
    error,
  };
};

export const markAsRead = (params: MarkAsReadRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(markAsReadStart());

      const url = `/sms-chat/mark-as-read`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(markAsReadSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(markAsReadFail(err));
          reject(err);
        });
    });
  };
};
